
import { Loader } from "@googlemaps/js-api-loader"

let loader = new Loader({
	apiKey: "AIzaSyARm95zbXVIPPB3qO9adjXN5ewAc94waHU",
	version: "weekly",
});


export async function loadMaps()
{
	return await loader.load();
}

export function createDirectionControl(map, coords) {
	const controlButton = document.createElement("button");
  
	// Set CSS for the control.
	controlButton.style.backgroundColor = "#fff";
	controlButton.style.border = "2px solid #fff";
	controlButton.style.borderRadius = "3px";
	controlButton.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
	controlButton.style.color = "rgb(25,25,25)";
	controlButton.style.cursor = "pointer";
	controlButton.style.fontFamily = "Roboto,Arial,sans-serif";
	controlButton.style.fontSize = "16px";
	controlButton.style.lineHeight = "38px";
	controlButton.style.margin = "0 0 25px";
	controlButton.style.padding = "0 10px";
	controlButton.style.textAlign = "center";
	controlButton.textContent = "Get directions";
	controlButton.title = "Get directions";
	controlButton.type = "button";

	controlButton.addEventListener("click", () => {
		window.open(`https://www.google.com/maps/dir//${coords.lat},${coords.lng}/@${coords.lat},${coords.lng},58877m/data=!3m1!1e3!4m2!4m1!3e0?entry=ttu&g_ep=EgoyMDI1MDQyMC4wIKXMDSoASAFQAw%3D%3D`)
	});

	const controlDiv = document.createElement("div");
	controlDiv.appendChild(controlButton);

	return controlDiv;
  }